import NewsList from '@/pages/NewsList.vue';

export default [
  {
    path: '/news/test',
    name: 'news-list',
    component: NewsList,
    meta: { title: 'Новости' },
  },
];
